<template>
    <a-modal v-model="visible" :title="null" :zIndex="1100" :footer="null" :width="760">
        <div class="content">
            <div class="content-head">通知详情</div>
            <div class="content-title">
                <div class="text1">{{result.title}}</div>
                <div class="text2">发布人：{{result.createBy|| '——'}} 发布时间：{{result.createTime || '——'}}</div>
                <a :style="{ display: 'block' ,marginTop: '14px' }" v-if="result.isRecord == 1" @click="toRemit">相关政策申报</a>
            </div>
            <div class="content-wrap">
                {{result.content}}
            </div>
        </div>
    </a-modal>
</template>

<script>
import Vue from 'vue'
import { Modal } from 'ant-design-vue'
Vue.use(Modal)
export default {
    name: "",
    components: {
        
    },
    data() {
        return {
            visible: false,
            result: {}
        };
    },
    created() {},
    mounted() {
    },
    methods: {
        hideModal() {
            this.visible = false;
        },
        openModal(item) {
            this.visible = true;
            this.$set(this,'result',item)
        },
        toRemit(){
            this.$router.push({ path: '/declare' , query: {itemId: this.result.policyId }})
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep .ant-modal-body {
    padding: 0;
}

.content {
    width: 100%;
    min-height: 500px;
    .content-head {
        width: 100%;
        height: 53px;
        background: #f0f4f9;
        border: 1px solid #dfdfdf;
        border-radius: 2px;
        font-size: 18px;
        font-weight: bold;
        color: #262626;
        line-height: 53px;
        text-indent: 30px;
        position: relative;
        &::before {
            content: "";
            width: 2px;
            height: 20px;
            background: #1976f8;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 20px;
        }
    }
    .content-title {
        padding: 24px 20px;
        border-bottom: 1px solid #e8e8e8;
        .text1 {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
        }
        .text2 {
            margin: 14px 0 0 0;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
        }
    }
    .content-wrap {
        padding: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
        color: #666666;
        text-align: justify;
    }
}
</style>
